/**
 * Dynamite brand-specific color overrides.
 * TODO: Replace placeholder values with actual Dynamite brand colors.
 * These are deep-merged on top of the shared color palette in foundations/colors.js.
 */
export default {
    brandMagenta: '#000000',
    brandMagentaText: '#000000',
    darkPink: '#333333',
    loyaltyT1: '#CCCCCC',
    loyaltyT2: '#999999',
    loyaltyT3: '#666666',
    loyaltyPink: '#F5F5F5',
    brand: {
        100: '#F0F0F0',
        500: '#25252B'
    },
    progressPink: {
        500: '#000000'
    },
    webTypo: {
        textPrimary: '#25252B',
        linkPrimary: '#25252B',
        textBrandLoyalty: '#25252B'
    },

    webTheme: {
        focus: '#C2684C',
        layerDefault: '#FFFFFF',
        layerActive: 'rgba(0, 0, 0, 0.3)',
        backgroundDefault: '#FFFFFF',
        backgroundPrimaryBrand: '#FCF8F2',
        backgroundSecondaryBrand: '#E8E0D1',
        backgroundReverse: '#25252B',
        backgroundLoyaltyCreator: '#F1BFAD',
        backgroundLoyaltyCreatorSecondary: '#F7DAD0',
        backgroundLoyaltyMuse: '#D8CAB0',
        backgroundLoyaltyMuseSecondary: '#F1BFAD',
        backgroundLoyaltyIcon: '#D4A03B',
        backgroundLoyaltyIconSecondary: '#E1BF7E',
        backgroundNotification: '#F1F1F1',
        fieldDefault: '#FFFFFF',
        fieldHover: '#F1F1F1',
        fieldHoverSelected: '#DBDBDB',
        fieldDisabled: '#F1F1F1',
        supportSuccess: '#048848',
        supportError: '#B30000',
        supportWarning: '#FFBB33',
        supportInfo: '#25252B',
        strokeDefault: '#25252B',
        strokeSecondary: '#767676',
        strokeDisable: '#AFAFAF',
        strokeTertiary: '#ECE9E9',
        strokeWarning: '#B30000',
        strokeReverse: '#FFFFFF',
        strokeInteractive: '#25252B',
        iconPrimary: '#25252B',
        iconOnColor: '#FFFFFF',
        iconDisabled: '#AFAFAF',
        iconLoyaltyCreator: '#F1BFAD',
        iconLoyaltyMuse: '#D8CAB0',
        iconLoyaltyIcon: '#D4A03B',
        tagDefault: '#FFFFFF',
        tagOnImage: 'rgba(255, 255, 255, 0.7)',
        tagReverse: '#25252B',
        tagBrand: '#E65D4B'
    },
    webButton: {
        btnPrimaryDefault: '#25252B',
        btnPrimaryHover: '#676767',
        btnSecondaryHover: '#25252B'
    },
    webTrasparency: {
        neutralTransparencyBlack: 'rgba(37, 37, 43, 0.30)'
    }
}
